import React from "react";
import FacilityFormPage from "../components/facilities/FacilityFormPage";

const FacilityEdit = () => <FacilityFormPage mode="edit" />;

export default FacilityEdit;
